import Component from "../../component";

export const CartCounterConfig = {
    signature: 'cartCounter',
    baseHtmlClass: 'cart_counter',
    selector: '.cart_counter',
    initedHtmlClassModifier: 'inited',
    datasetConfigKey: 'cart_counter',
    identifierDatasetConfigKey: 'identifier',
    changedEventName: 'StoneArrow:CartCounter::Changed'
};

export class CartCounter extends Component {

    static applyToAll() {
        document.querySelectorAll(CartCounterConfig.selector).forEach((element) => {
            if (!CartCounter.isElementComponentized(element, CartCounterConfig.signature)) new CartCounter(element);
        });
    }

    constructor(id_or_element, props = {}) {
        super({
            element: id_or_element,
            config: CartCounterConfig
        });

        this.data = null;
        this.counterValue = null;
        this.setDatasetConfig(CartCounterConfig.datasetConfigKey);

        if (this.element) {
            const mutationConfig = { attributes: false, childList: true, subtree: true };
            new MutationObserver(this.handleMutation.bind(this)).observe(this.element, mutationConfig);
        }

        this.element.addEventListener(CartCounterConfig.changedEventName, (event)=>{
            this.render();
        });
    }

    handleMutation(mutations, observer){
        this.extractData();
        this.element.dispatchEvent(new CustomEvent(CartCounterConfig.changedEventName, { detail: this.data }));
    }

    extractData(){
        this.counterValue = this.extractCounterValue();
        this.data = {};
    }

    render() {
        this.conditionallySetHtmlClassState(this.counterValue === 0, 'empty');
    }

    extractCounterValue() {
        let value = this.element.innerText;
        if (value === '') return null;
        value = parseInt(value);
        if (Number.isNaN(value)) return null;
        return value;
    }

}
